import { NavLink } from 'react-router-dom';
import type { User } from 'firebase/auth';
import { signOutUser } from '../../lib/firebase.ts';
import { IconChat, IconClose, IconGauge, IconSignOut, Mark } from '../ui/Icons.tsx';

const NAV = [
  { to: '/', label: 'Workspace', Icon: IconChat },
  { to: '/command-center', label: 'Command center', Icon: IconGauge },
];

export function Sidebar({ user, onClose }: { user: User; onClose?: () => void }) {
  const initial = (user.displayName || user.email || '?').trim().charAt(0).toUpperCase();

  return (
    <nav className="lx-side">
      <div className="lx-brand">
        <Mark size={26} />
        <span style={{ flex: 1 }}>Lumlix</span>
        {onClose && (
          <button className="lx-icon-btn lx-focus" onClick={onClose} aria-label="Close menu">
            <IconClose />
          </button>
        )}
      </div>

      <div className="lx-nav">
        {NAV.map(({ to, label, Icon }) => (
          <NavLink key={to} to={to} end className={({ isActive }) => (isActive ? 'is-active lx-focus' : 'lx-focus')}>
            <Icon size={17} />
            {label}
          </NavLink>
        ))}
      </div>

      <div className="lx-side-foot">
        <span className="lx-avatar" aria-hidden>{initial}</span>
        <span className="lx-who">
          <span className="lx-email" title={user.email ?? undefined}>{user.email}</span>
        </span>
        <button
          className="lx-icon-btn lx-focus"
          onClick={() => void signOutUser()}
          aria-label="Sign out"
          title="Sign out"
          style={{ width: 32, height: 32 }}
        >
          <IconSignOut size={16} />
        </button>
      </div>
    </nav>
  );
}
